// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3bHOo","avatar":"style_avatar__1sX33","menuIcon":"style_menuIcon__wFozk"};